import React, { useCallback, useContext, useMemo } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { FlexColumn, FormModal } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { API_DATE_FORMAT, MAIN_PROJECT_NO_COLOR } from '@ubeya/shared/constants';
import MainProjectDetailsStep from '../MainProjectDetailsStep';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: 16px;
`;

const EditMainProjectModal = ({ onClose, onSubmit, mainProject }) => {
  const { t } = useContext(ConfigContext);
  const existingBranchIds = useMemo(() => mainProject?.branchIds || [], [mainProject?.branchIds]);

  const initialValues = useMemo(() => {
    return {
      name: mainProject?.name ?? '',
      identifier: mainProject?.identifier ?? '',
      startTime: mainProject?.startTime ?? null,
      doorTime: mainProject?.doorTime ?? null,
      color: mainProject?.color ?? MAIN_PROJECT_NO_COLOR,
      selectedBranchIds: existingBranchIds,
      dateRange: {
        startDate: mainProject?.startDate ? moment(mainProject.startDate) : moment(),
        endDate: mainProject?.endDate ? moment(mainProject.endDate) : moment()
      },
      glCode: mainProject?.glCode ?? '',
      estimatedAttendance: mainProject?.estimatedAttendance ?? null,
      expectedRevenue: mainProject?.expectedRevenue ?? null,
      totalActualRevenue: mainProject?.totalActualRevenue ?? null,
      actualAttendance: mainProject?.actualAttendance ?? null
    };
  }, [existingBranchIds, mainProject]);

  const handleSubmit = useCallback(
    async (values) => {
      const existingBranchIdsSet = new Set(existingBranchIds);
      const addedBranchIds = (values.selectedBranchIds || []).filter(
        (branchId) => typeof branchId === 'number' && !existingBranchIdsSet.has(branchId)
      );

      await onSubmit({
        id: mainProject.id,
        name: values.name,
        identifier: values.identifier || null,
        startTime: values.startTime || null,
        doorTime: values.doorTime || null,
        color: values.color !== MAIN_PROJECT_NO_COLOR ? values.color : null,
        startDate: values.dateRange?.startDate ? moment(values.dateRange.startDate).format(API_DATE_FORMAT) : undefined,
        endDate: values.dateRange?.endDate ? moment(values.dateRange.endDate).format(API_DATE_FORMAT) : undefined,
        glCode: values.glCode || null,
        estimatedAttendance: values.estimatedAttendance ?? null,
        expectedRevenue: values.expectedRevenue ?? null,
        totalActualRevenue: values.totalActualRevenue ?? null,
        actualAttendance: values.actualAttendance ?? null,
        ...(addedBranchIds.length > 0 && { branches: { added: addedBranchIds } })
      });
    },
    [existingBranchIds, onSubmit, mainProject]
  );

  return (
    <FormModal
      initialValues={initialValues}
      onSubmit={handleSubmit}
      size="medium"
      onClose={onClose}
      title={t('editMainEvent')}
      confirmText="save"
      showCancelButton>
      <Wrapper>
        <MainProjectDetailsStep lockedBranchIds={existingBranchIds} />
      </Wrapper>
    </FormModal>
  );
};

export default EditMainProjectModal;
